import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler'
import { authHeader, authHeaderJson } from '../_helpers/auth-header'

import { config } from '../config'
const base_url = config.apiUrl

export const userService = {
  login,
  loginMembers,
  logout,
  register,
  getAll,
  getRoles,
  getUserRoles,
  getById,
  update,
  add,
  edit,
  delete: _delete
}

function login(username, password) {
  // let formData = {};
  // formData["email"] = username;
  // formData["password"] = password;
  // let data = JSON.stringify(formData);

  const url = base_url + 'User/Authenticate/' + username + '/' + password

  // console.log(url)
  return axios
    .get(url)
    .then(function(response) {
      // console.log(response.data)

      let data = response.data

      localStorage.setItem('token', data.token)
      let user = {}
      user['userName'] = data.username
      user['firstName'] = data.firstName
      user['lastName'] = data.lastName
      user['mobile'] = data.mobile
      user['role'] = data.userType
      user['logo'] = data.avatar
      user['token'] = data.token
      user['unionName'] = data.unionName
      user['permissions'] = data.permissions
        .filter(el => el.access == true)
        .map(el => el.accessType)
      localStorage.setItem('user', JSON.stringify(user))
      return user
    })
    .catch(function(error) {
      // console.log(error)
    })
}

function loginMembers(mobile, nationalCode, unionId) {
  // let formData = {};
  // formData["email"] = username;
  // formData["password"] = password;
  // let data = JSON.stringify(formData);

  const url =
    base_url +
    'Member/' +
    mobile +
    '/' +
    nationalCode +
    '/' +
    unionId +
    '/authetication'

  // console.log(url)
  return axios
    .get(url)
    .then(function(response) {
      // console.log(response.data)

      let data = response.data

      localStorage.setItem('token', data.token)
      let user = {}
      user['id'] = data.id
      user['gender'] = data.gender
      user['firstName'] = data.firstName
      user['lastName'] = data.lastName
      user['mobile'] = data.mobile
      user['nationalCode'] = data.nationalCode
      // user["logo"] = data.avatar;
      user['token'] = data.token
      user['unionName'] = data.union.name
      // user["permissions"] = data.permissions.filter(el => el.access == true).map(el => el.accessType);
      localStorage.setItem('user', JSON.stringify(user))
      return user
    })
    .catch(function(error) {
      // console.log(error)
    })
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user')
}

function getAll() {
  const url = base_url + 'Users'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getRoles() {
  const url = `api/Roles`
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getUserRoles(id) {
  const url = `api/UserRoles/` + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function add(form) {
  const url = 'api/User'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, form, { headers: authHeaderJson() })
}

function edit(id, form) {
  const url = 'api/User/'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.put(url, form, { headers: authHeader() })
}

function _delete(id) {
  const url = 'api/Users/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.delete(url, { headers: authHeader() })
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`api/users/${id}`, requestOptions).then(handleResponse)
}

function register(user) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user)
  }

  return fetch(`api/users/register`, requestOptions).then(handleResponse)
}

function update(user) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(user)
  }

  return fetch(`api/users/${user.id}`, requestOptions).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout()
        //location.reload(true);
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}
